import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import App from "./components/App";
import CssBaseline from "@material-ui/core/CssBaseline";
import {createMuiTheme} from '@material-ui/core/styles';
import {ThemeProvider} from '@material-ui/styles';
import {purple} from '@material-ui/core/colors';
import {lightGreen} from '@material-ui/core/colors';

// const theme = createMuiTheme({
//   palette: {
//     primary: {main: lightGreen[500]},
//     secondary: {main: purple[500]},
//   },
// });
const theme = createMuiTheme({
  palette: {
    primary: lightGreen,
    secondary: purple,
  },
});

ReactDOM.render(
  <React.Fragment>
    <CssBaseline/>
    <ThemeProvider theme={theme}>
      <App/>
    </ThemeProvider>
  </React.Fragment>
  , document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
